import { render, staticRenderFns } from "./Mine.vue?vue&type=template&id=860da2d0&scoped=true"
import script from "./Mine.vue?vue&type=script&lang=js"
export * from "./Mine.vue?vue&type=script&lang=js"
import style0 from "./Mine.vue?vue&type=style&index=0&id=860da2d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860da2d0",
  null
  
)

export default component.exports